import { render, staticRenderFns } from "./GestionCBI.vue?vue&type=template&id=2726d622&scoped=true"
import script from "./GestionCBI.vue?vue&type=script&lang=js"
export * from "./GestionCBI.vue?vue&type=script&lang=js"
import style0 from "./GestionCBI.vue?vue&type=style&index=0&id=2726d622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726d622",
  null
  
)

export default component.exports